import NiceModal, { useModal } from '@ebay/nice-modal-react';
import type { UseMutationResult } from '@tanstack/react-query';
import { useState } from 'react';
import Confirm from '@/components/UI/Modal/Confirm';

interface DeleteConfirmationModalProps {
  title: string;
  id: number;
  deleteMutation: UseMutationResult;
}

export const DeleteConfirmationModal = NiceModal.create(({ title, id, deleteMutation }: DeleteConfirmationModalProps) => {
  const modal = useModal();
  const [isLoading, setIsLoading] = useState(false);

  const onConfirm = async () => {
    setIsLoading(true);
    try {
      await deleteMutation.mutateAsync(id);
      modal.hide();
      setIsLoading(false);
    } catch {
      setIsLoading(false);
    }
  };

  const onCancel = () => {
    modal.hide();
  };

  if (!modal.visible) return null;

  return (
    <Confirm
      title={title}
      message='Please confirm that you would like to make these changes'
      acceptButtonLabel={`${isLoading ? 'Deleting...' : 'Delete'}`}
      declineButtonLabel='Cancel'
      accept={onConfirm}
      decline={onCancel}
    />
  );
});
